import { render, staticRenderFns } from "./StudentCsvImport.vue?vue&type=template&id=2f7873fc&"
import script from "./StudentCsvImport.vue?vue&type=script&lang=js&"
export * from "./StudentCsvImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports